"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsDesktop = void 0;
const react_1 = require("react");
const theme_1 = require("@pulse-web-ui/theme");
const use_window_size_1 = require("./use-window-size");
const useIsDesktop = (desktopWidth) => {
    const [width = 360] = (0, use_window_size_1.useWindowSize)();
    return (0, react_1.useMemo)(() => width >= (desktopWidth !== null && desktopWidth !== void 0 ? desktopWidth : theme_1.breakpoints.DESKTOP), [width, desktopWidth]);
};
exports.useIsDesktop = useIsDesktop;
